<div class="custom-input-container">
  <label>{{ label }} <span *ngIf="IsRequired" class="required-asterisk">*</span></label>
  <input
    [type]="type"
    [placeholder]="placeholder"
    [attr.maxlength]="maxlength"
    [value]="value"
    (input)="onInput($event)"
    [disabled]="isDisabled"
    (keydown)="onKeyDown($event)"
    (blur)="onBlur()"
    #inputElement
    [ngClass]="{'error-field': (formControlName == 'PharmacyPhone' ? (isFieldInvalid(formControlName) && !phoneNumExists) :  isFieldInvalid(formControlName))}"
  />
<div *ngIf="((formControlName == 'PharmacyPhone' ? (isFieldInvalid(formControlName) && !phoneNumExists) :  isFieldInvalid(formControlName)) || ((IsDrugNotFound || IsPharmacyNotFound) && value.length > 3))" 
     class="error_msg_required">
  {{
    (IsDrugNotFound || IsPharmacyNotFound) && value.length > 3
      ? (IsDrugNotFound 
          ? 'The entered drug is invalid, Please select another.' 
          : 'The entered pharmacy could not be found. Do you wish to proceed?')
      : label + ' selection is required'
  }}
</div>

  <span class="material-symbols-outlined search-icon" *ngIf="ShowSearchIcon" (click)="onSearchClicked()">search</span>
    <div *ngIf="EnableSuggestions && showSuggestions" class="suggestions-dropdown">
    <ul class="dropdown-list" (scroll)="onDrugSuggestionScroll($event)" (click)="closeSuggestions()" *ngIf="FilteredData">
        <li *ngFor="let suggestion of FilteredData" (pointerdown)="handlePointer($event, suggestion)" (pointerup)="handlePointer($event, suggestion)" class="dropdown_item">
           <div class="drug_result_card" *ngIf="fieldName === 'DrugName'">
           <div class="drug-main-line">
           {{ (suggestion?.drugname + ' ' + suggestion?.strength + ' '  + suggestion?.drugformname) | titlecase }}
          </div>
          <!-- <div class="ndc-line">
            NDC: {{  (suggestion?.ndc?.toString().padStart(11, '0') | slice:0:5) + '-' +
            (suggestion?.ndc?.toString().padStart(11, '0') | slice:5:9) + '-' +
            (suggestion?.ndc?.toString().padStart(11, '0') | slice:9:11)}}
          </div> -->
        </div>
        <div *ngIf="fieldName !== 'DrugName'">
          {{ suggestion?.pharmName }}
        </div>
      </li>
    </ul>
  </div>
</div>